import React from "react";
import classes from "./Layout.module.css";
import Header from "./Header";
import LandingPageFooter from "../components/LandingPageFooter";

function Layout({ children }) {
  return (
    <section className={classes.section}>
      <div className={classes.header}>
        <Header />
      </div>
      <div className={classes.mainContent}>{children}</div>
      <div className={classes.footer}>
        <LandingPageFooter />
      </div>
    </section>
  );
}

export default Layout;
